import { render, staticRenderFns } from "./InsurancePriceList.vue?vue&type=template&id=4c21868d"
import script from "./InsurancePriceList.vue?vue&type=script&lang=js"
export * from "./InsurancePriceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports